import {materialConnection} from "#material/nodes/base/connection/shorthand"
import {Color as ColorNode} from "#material/nodes/input/color/color"
import type {OutputMaterialConnection} from "#material/sockets/definition"
import type {Color} from "@cm/graph-v3"

export const color = (color: Color): OutputMaterialConnection<"color"> => {
    return materialConnection(new ColorNode({parameters: {inputs: {}, settings: {color: color}}}), "color")
}
